 <template>
  <div class="login-main">
    <img
      class="posImg logo"
      @click="goUrl('/')"
      src="@/assets/image/common/logo-bule.png"
    />
    <img class="posImg top" src="@/assets/image/login/top.png" />
    <img class="posImg bottom" src="@/assets/image/login/bottom.png" />
    <div class="content">
      <div class="img-box">
        <img src="@/assets/image/login/img-icon.png" />
        <div class="text-box">
          <span class="share">{{ $t("login.titleBox.title1") }}</span>
          <span>{{ $t("login.titleBox.title2") }}</span>
        </div>
      </div>
      <div class="content-box">
        <div class="herder">
          {{ $t("login.titleBox.title19") }}
        </div>
        <div class="from-box" v-if="next === 1">
          <div class="title">{{ $t("login.titleBox.title5") }}</div>
          <input v-model="phone" :placeholder="$t('login.titleBox.title7')" />
        </div>

        <div class="from-box" v-if="next === 1">
          <div class="title">{{ $t("common.register.smsCode") }}</div>
          <div class="button-box">
            <input
              v-model="validCode"
              :placeholder="$t('login.titleBox.title8')"
            />
            <button
              type="primary"
              :class="timer ? 'timer' : ''"
              :disabled="timer"
              @click="doGeetest"
            >
              {{
                timer
                  ? $t("common.register.getAfterSeconds", { seconds: time })
                  : $t("common.register.getCode")
              }}
            </button>
          </div>
        </div>
        <div class="from-box" v-if="next === 2">
          <div class="title">{{ $t("login.titleBox.title4") }}</div>
          <div class="password-box">
            <input
              v-model="password"
              :placeholder="$t('login.titleBox.title17')"
              :type="passwordType"
            />
            <img
              class="eyes"
              v-if="passwordType === 'password'"
              @click="passwordType = 'text'"
              src="@/assets/image/login/close-eyes.png"
            />
            <img
              class="eyes"
              v-if="passwordType === 'text'"
              @click="passwordType = 'password'"
              src="@/assets/image/login/open-eyes.png"
            />
          </div>
        </div>
        <div class="from-box" v-if="next === 2">
          <div class="title">确认密码</div>
          <div class="password-box">
            <input
              v-model="confirmPassword"
              :placeholder="$t('login.titleBox.title17')"
              :type="passwordType2"
            />
            <img
              class="eyes"
              v-if="passwordType2 === 'password'"
              @click="passwordType2 = 'text'"
              src="@/assets/image/login/close-eyes.png"
            />
            <img
              class="eyes"
              v-if="passwordType2 === 'text'"
              @click="passwordType2 = 'password'"
              src="@/assets/image/login/open-eyes.png"
            />
          </div>
        </div>

        <div class="from-box from-box2" v-if="next === 2">
          <div class="btn" @click="next = 1">
            {{ $t("common.register.previousStep") }}
          </div>
        </div>
        <div class="sunmit" v-if="next === 1" @click="chengeNext">
          {{ $t("login.titleBox.title23") }}
        </div>
        <div class="sunmit sunmit2" v-if="next === 2" @click="setRegistry">
          {{ $t("login.titleBox.title21") }}
        </div>
        <div class="checkbox-fa">
          <div class="text">
            <el-checkbox v-model="checked"></el-checkbox>
            已阅读并同意<span @click="goUrl(`/module/help?id=2&number=6`)"
              >【{{ $t("login.titleBox.title12") }}】</span
            >和<span @click="goUrl(`/module/help?id=2&number=7`)"
              >【{{ $t("login.titleBox.title13") }}】</span
            >
          </div>
        </div>
        <div class="footer">
          <div class="left" @click="goUrl('/login')">
            {{ $t("login.titleBox.title18") }}
          </div>
          <div class="right">
            <span>{{ $t("login.titleBox.title15") }}</span>
            <img src="@/assets/image/login/weixin.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { geetestMixin } from "@/mixin/geetest.mixin";
import { getCaptcha, getRegistryCode, setRegistry } from "@/api/user";
export default {
  data() {
    return {
      timer: null,
      time: 180,
      checked: false,
      base64: null,
      next: 1,
      passwordType: "password",
      passwordType2: "password",
      phone: null,
      password: null,
      confirmPassword: null,
      captchaCode: null,
      captchaKey: null,
      validCode: null,
      channelId: null,
      channelUserId: null,
      referrerId: null,
    };
  },
  mixins: [geetestMixin],
  methods: {
    goUrl(path) {
      this.$router.push(path);
    },
    //验证码
    getCaptcha() {
      getCaptcha().then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.captchaKey = res.data.id;
          this.base64 = "data:image/png;base64," + res.data.base64;
        }
      });
    },
    chengeNext() {
      if (!this.checked) {
        this.$message.warning("请先同意隐私政策和服务协议");
        return;
      }
      if (!this.phone) {
        this.$message.warning("手机号不能为空");
        return;
      }

      if (!this.validCode) {
        this.$message.warning("请填写正确的验证码");
        return;
      }
      this.next = 2;
    },
    //手机验证码
    doGeetest() {
      if (!this.phone) {
        this.$message.warning("请先填写手机号");
        return;
      }

      if (!this.geetest.geetestObj) {
        /*
            如果this.geetest.geetestFatched==true，则说明已经加载过极验了
            如果this.geetest.showGeetest==false，则说明后台关闭极验了
           */
        if (this.geetest.geetestFatched && !this.geetest.showGeetest) {
          this.confirmSendVerifyCode();

          console.log("触发--1");
        } else {
          this.initGeetest({
            product: "bind",
            lang: this.getLang.code,
          });

          console.log("触发00");
        }
      } else {
        console.log("触发测试");
        if (this.geetest.showGeetest) {
          this.geetestShow();
          console.log("触发111");
        } else {
          console.log("触发222");
          this.getRegistryCode();
        }
      }
    },

    getRegistryCode() {
      getRegistryCode({
        phone: this.phone,
        geetestChallenge: this.geetest.geetestSuccessData.geetest_challenge,
        geetestValidate: this.geetest.geetestSuccessData.geetest_validate,
        geetestSeccode: this.geetest.geetestSuccessData.geetest_seccode,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("验证码已发送，请注意接听手机");
          this.timer = setInterval(() => {
            this.time = this.time - 1;
            if (this.time === 1) {
              this.time = 180;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      });
    },

    // 极验验证成功后回调
    onGeetestSuccess() {
      // 用户通过极验行为验证后做的操作
      this.getRegistryCode();
    },
    // 极验被禁用后回调
    onDisableGeetest() {
      this.getRegistryCode();
    },

    //注册
    setRegistry() {
      if (!this.checked) {
        this.$message.warning("请先同意隐私政策和服务协议");
        return;
      }
      setRegistry({
        phone: this.phone,
        password: this.password,
        confirmPassword: this.confirmPassword,
        validCode: this.validCode,
        captchaKey: this.captchaKey,
        captchaCode: this.captchaCode,
        yes: this.checked,
        channelId: this.channelId,
        channelUserId: this.channelUserId,
        referrerId: this.referrerId,
      }).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.$message.success("注册成功");
          this.$router.push("/login");
        }
      });
    },
  },
  created() {
    this.getCaptcha();

    if (this.$route.query.web) {
      this.channelId = this.$route.query.web;
    }
    if (this.$route.query.uid) {
      this.channelUserId = this.$route.query.uid;
    }
    if (this.$route.query.refer) {
      this.referrerId = this.$route.query.refer;
    }
  },
};
</script>
<style lang="scss" scoped>
.login-main {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  .posImg {
    position: absolute;
    z-index: 1;
  }
  .logo {
    width: 156px;
    height: 52.5px;
    top: 46px;
    left: 147px;
    cursor: pointer;
  }
  .top {
    width: 246px;
    height: 226px;
    top: 0;
    right: 0;
  }
  .bottom {
    width: 246px;
    height: 229px;
    bottom: 0;
    left: 0;
  }
  .content {
    width: 1032px;
    height: 550px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    display: flex;
    box-shadow: 0px 0px 30px 1px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    .img-box {
      flex-shrink: 0;
      width: 50%;
      background: #f3edfd;
      img {
        width: 425px;
        height: 380px;
        margin-top: 70px;
        margin-left: 46px;
      }
      .text-box {
        display: flex;
        font-size: 22px;
        justify-content: center;
        margin-top: 28px;
        .share {
          margin-right: 42px;
          color: #8948ff;
        }
      }
    }
    .content-box {
      width: 50%;
      .herder {
        display: flex;
        color: #232323;
        font-size: 20px;
        font-weight: bolder;
        margin-top: 39px;
        justify-content: center;
        width: 370px;
        margin-left: 67px;
        div {
          cursor: pointer;
        }
        .active {
          color: #8948ff;
        }
      }
      .from-box {
        width: 370px;
        margin-left: 67px;
        .title {
          margin-top: 32px;
          font-size: 14px;
          color: #232323;
          margin-bottom: 13px;
        }
        .code-box {
          display: flex;
          justify-content: space-between;
          input {
            width: 220px;
            flex-shrink: 0;
          }
          img {
            flex-shrink: 0;
            width: 130px;
            height: 48px;
            cursor: pointer;
          }
        }
        .password-box {
          position: relative;
          input {
            padding-right: 50px;
            box-sizing: border-box;
          }
          .eyes {
            position: absolute;
            width: 30px;
            height: 30px;
            cursor: pointer;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        .button-box {
          position: relative;
          input {
            padding-right: 100px;
            box-sizing: border-box;
          }
          button {
            position: absolute;
            cursor: pointer;
            right: 10px;
            background-color: #fafafa;
            top: 50%;
            transform: translateY(-50%);
            border: none;
            color: #6556fa;
            cursor: pointer;
          }
          .timer {
            cursor: no-drop;
            opacity: 0.5;
          }
        }
        .btn {
          color: #6556fa;
          margin-top: 20px;
          cursor: pointer;
        }
        input {
          border: none;
          outline: none;
          background-color: #fafafa;
          width: 100%;
          height: 48px;
          font-size: 14px;
          padding: 0 24px;
          box-sizing: border-box;
        }
        input::placeholder {
          color: #999;
          opacity: 1;
        }
      }
      .from-box2 {
        display: flex;
        justify-content: flex-end;
      }
      .flot {
        float: left;
        margin-left: 67px;
        margin-top: 19px;
        color: #6556fa;
        font-size: 14px;
        cursor: pointer;
      }
      .sunmit {
        display: block;
        border: none;
        padding: 0;
        width: 370px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #8846ff;
        border-radius: 4px 4px 4px 4px;
        margin-left: 67px;
        margin-top: 50px;
        cursor: pointer;
        color: #fff;
      }
      .sunmit {
        margin-top: 20px;
      }
      .checkbox-fa {
        width: 370px;
        margin-left: 67px;
        display: flex;
        margin-top: 40px;
        align-items: center;
        .text {
          font-size: 14px;
          color: #232323;
          margin-left: 3px;
          span {
            color: #8948ff;
            cursor: pointer;
          }
        }
      }
      .footer {
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 370px;
        margin-left: 67px;
        margin-top: 30px;
        .left {
          color: #8948ff;
          cursor: pointer;
        }
        .right {
          display: flex;
          color: #232323;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
            margin-left: 21px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1100px) {
  .login-main {
    .content {
      width: 516px;
      .img-box {
        display: none;
      }
      .content-box {
        width: 100%;
      }
    }
  }
}
/* 媒体查询 */
@media only screen and (max-width: 750px) {
  .login-main {
    background-color: #f7f8fa;
    .logo {
      width: 104px;
      height: 35px;
      top: 15px;
      left: 15px;
    }
    .top {
      display: none;
    }
    .bottom {
      display: none;
    }
    .content {
      width: calc(100% - 30px);
      margin-left: 15px;
      left: 0;
      transform: translateY(-50%);
      padding: 15px;
      box-sizing: border-box;
      .img-box {
        display: none;
      }
      .content-box {
        width: 100%;
        .herder {
          display: flex;
          color: #232323;
          font-size: 20px;
          font-weight: bolder;
          margin-top: 39px;
          justify-content: center;
          width: 100%;
          margin-left: 0;
          div {
            cursor: pointer;
          }
          .active {
            color: #8948ff;
          }
        }
        .from-box {
          width: 100%;
          margin-left: 0;
          .title {
            margin-top: 32px;
            font-size: 14px;
            color: #232323;
            margin-bottom: 13px;
          }
          .code-box {
            display: flex;
            justify-content: space-between;
            input {
              width: 220px;
              flex-shrink: 0;
            }
            img {
              flex-shrink: 0;
              width: 130px;
              height: 48px;
            }
          }
          input {
            border: none;
            outline: none;
            background-color: #fafafa;
            width: 100%;
            height: 48px;
            font-size: 14px;
            padding: 0 24px;
            box-sizing: border-box;
          }
          input::placeholder {
            color: #999;
            opacity: 1;
          }
        }
        .flot {
          float: left;
          margin-left: 0;
          margin-top: 19px;
          color: #6556fa;
          font-size: 14px;
          cursor: pointer;
        }
        .sunmit {
          display: block;
          border: none;
          padding: 0;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #8846ff;
          border-radius: 4px 4px 4px 4px;
          margin-left: 0;
          margin-top: 50px;
          cursor: pointer;
          color: #fff;
        }
        .checkbox-fa {
          width: 100%;
          margin-left: 0;
          display: flex;
          margin-top: 40px;
          align-items: center;
          .text {
            font-size: 14px;
            color: #232323;
            margin-left: 3px;
            span {
              color: #8948ff;
            }
          }
        }
        .footer {
          font-size: 14px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          margin-left: 0;
          margin-top: 30px;
          .left {
            color: #8948ff;
            cursor: pointer;
          }
          .right {
            display: flex;
            color: #232323;
            align-items: center;
            img {
              width: 30px;
              height: 30px;
              margin-left: 21px;
            }
          }
        }
      }
    }
  }
}
</style>